import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {PagesStore} from '../@store';
import {Page} from '@core/interfaces/common/pages';

@Injectable()
export class RerouteGuard implements CanActivate {
    constructor(private pagesStore: PagesStore, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
        const data = this.router.getCurrentNavigation().extras.state
            ? this.router.getCurrentNavigation().extras.state
            : null;

        return this.pagesStore.pageGroups$.pipe(
            filter((pageGroups) => !!pageGroups),
            map((pageGroups: Page[]) => {
                let currentGroup = null;
                try {
                    currentGroup = []
                        .concat(...pageGroups.map((group) => group.children))
                        .find((group) => state.url.indexOf(group.link) >= 0);
                } finally {
                }

                let currentPage = null;
                try {
                    if (currentGroup) {
                        currentPage = currentGroup.children.find((page) => state.url.indexOf(page.link) >= 0);
                    }
                } finally {
                }

                let currentTab = null;
                try {
                    if (currentPage && currentPage.children) {
                        currentTab = currentPage.children.find((tab) => state.url.indexOf(tab.link) >= 0);
                    }
                } finally {
                }

                let currentView = null;
                try {
                    if (currentTab && currentTab.children) {
                        currentView = currentTab.children.find((view) => state.url.indexOf(view.link) >= 0);
                    }
                } finally {
                }

                // If navigating in to a page for the first time, check the default route
                // Account for extra data (e.g., study assets -> asset details)
                const queryParams: Params = route.queryParams;
                let queryCommand: string;
                if (currentPage && currentTab && currentView) {
                    return true;
                }
                if (!currentPage) {
                    queryCommand = currentGroup?.redirectTo;
                } else if (!currentTab) {
                    queryCommand = currentPage.redirectTo;
                } else if (!currentView) {
                    queryCommand = currentTab.redirectTo;
                }
                this.router.navigateByUrl(this.router.createUrlTree([queryCommand], {queryParams: queryParams}), {
                    state: data,
                });
            }),
        );
    }
}
